import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as me from '../../me'
import * as apps from '../apps'
import * as contexts from '../contexts'
import * as pages from '../pages'
import * as portalAccess from '../portal-access'

import { Api } from './api.service'
import type { TypeParams } from './types'
/**
 * Provides a collection of pages within the context of the selected
 * application.
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    const _contexts = ngCore.inject(contexts.Feature)
    const _meFeature = ngCore.inject(me.Feature)
    const appsEc = ngCore.inject(apps.Collection)
    /** @see {@link pages.Collection} */
    const pagesEc = ngCore.inject(pages.Collection)

    super({
      api: ngCore.inject(Api),
      context$: _contexts.selectors.appContext.asObservable,
      identify: ({ id }) => id,
      name: ec.Name.Predefined.AdminAppPage,
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory<TypeParams>(collection => ({
            rowConfig: ({ entity: appPage }) => ({
              iconsConfigs: [
                ...(portalAccess.ContentActionAccess.canEditOwnedChild({
                  context: _contexts.selectors.appContext.asSignal(),
                  entity: appsEc.plugins.currentEntityPlugin.feature.selectors
                    .getEntity()
                    .asSignal(),
                  user: _meFeature.selectors.currentUser.asSignal(),
                })
                  ? [
                      {
                        class: 'atn-icon atn-edit atn-blue',
                        onClick: () => {
                          const source = `Table.Row-${appPage.id}.Icons.Edit.Clicked`
                          // Check if it already exists
                          if (
                            collection.plugins.currentEntityPlugin.feature.selectors
                              .getEditedEntity()
                              .asSignal()
                          ) {
                            // discard the current edit
                            collection.plugins.editingPlugin.feature.actions.discard
                              .from(source)
                              .dispatch({
                                current: true,
                              })
                          }

                          // start a new edit
                          collection.plugins.editingPlugin.feature.actions.edit
                            .from(source)
                            .dispatch({
                              id: appPage.id,
                            })

                          pagesEc.plugins.selectionPlugin.applied.actions.putInSelectionLookup
                            .from(source)
                            .dispatch({
                              key: pages.SELECTION_TARGET,
                              value: { set: appPage.pageId },
                            })
                        },
                      },
                    ]
                  : []),
                ...(portalAccess.ContentActionAccess.canDeleteChild({
                  context: _contexts.selectors.appContext.asSignal(),
                  entity: appsEc.plugins.currentEntityPlugin.feature.selectors
                    .getEntity()
                    .asSignal(),
                  user: _meFeature.selectors.currentUser.asSignal(),
                })
                  ? [
                      {
                        class: 'atn-icon atn-trash atn-red',
                        onClick: () => {
                          collection.plugins.editingPlugin.feature.actions.markForDeletion
                            .from(`Table.Row-${appPage.id}.Icons.Trash.Clicked`)
                            .dispatch({ id: appPage.id })
                        },
                      },
                    ]
                  : []),
              ],
            }),
          })),
        ],
      },
    })
  }
}
